import React, {useEffect} from "react";
import loadable from "@loadable/component";
import PageLoader from "../../../components/shared/page-loader";
import PropTypes from "prop-types";

const CarDetailsRevamp = loadable(() => import("../../../components/au.desktop/car-details-revamp"), {
    fallback: <PageLoader />
});
import withAULayout from "../../../components/au.desktop/layout";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

const CarDetail = ({showDesktopCdpRevamp}) => {
    const {data = ""} = showDesktopCdpRevamp || {};
    useEffect(() => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.DESKTOP_CDP_REVAMP, {
            eventLabel: data
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * removed car details component
     * const CarDetails = loadable(() => import("../../../components/au.desktop/car-details"), {
        fallback: <PageLoader />
        });
     */
    return  <CarDetailsRevamp/>;
};
CarDetail.propTypes = {
    showDesktopCdpRevamp: PropTypes.object
};
export default withAULayout(CarDetail, true, true, {headerProps: {showEmailIcon: true, showWhiteMenu: false, showBlueMenu: true}});
